// extracted by mini-css-extract-plugin
var _1 = "SearchButton-moduleSearchButton__ZJ6z2";
export { _1 as "SearchButton" }
